import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import AddLocations from './AddLocations';
import Pagination from '@components/Shared/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import Loading from '@components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import UppdateLocations from '../../../HR/settings/Location/EditLocation/EditLocation';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [Id, setId] = useState('');
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(6);
  const { t, i18n } = useTranslation();
  // const dispatch = useAppDispatch();
 
  const { Locations, loading, error } = useGetLocations();

  const filteredSearch = Locations?.slice()?.filter((item: any) => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.name?.toLowerCase().includes(searchLowerCase) ||
      item.name2?.toLowerCase().toString().includes(searchLowerCase)
    );
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);
  //________________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Locations',
              link: null
            }
          ]}
          PageName='Locations'
        />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddLocation')}
            href='#/'
            className='btn btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddLocation'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddLocation')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row mb-4'>
              <div className='col-md-12'>
                <div className='input-group'>
                  <span className='input-group-text fw-bold'>
                    <i className='fa fa-search text-theme me-2'></i>
                    {t('Search')}
                  </span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control  '
                    onChange={e => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='mb-5'>
              <div className='row g-4'>
                {currentData?.map((item: any) => (
                  <div className='col-md-4' key={item.id}>
                    <Card className='h-100 shadow-sm'>
                      <div className='card-body d-flex flex-column'>
                        {/* إضافة أيقونة الموقع هنا */}
                        <div className='d-flex align-items-center mb-2'>
                          <i className='fas fa-map-marker-alt text-theme me-2'></i>
                          <h5 className='card-title mb-0'>{i18n.language === 'ar' ? item.name2 : item.name}</h5>
                        </div>

                        <div className='mb-3 position-relative'>
                          <iframe
                            className='rounded shadow-sm'
                            title={i18n.language === 'ar' ? item.name2 : item.name}
                            src={`https://www.google.com/maps/embed/v1/place?q=${item.latitude},${item.longitude}&key=AIzaSyCG3Kt_jO8o7x67EsdV9RuTJP5IxSEwmeo`}
                            style={{
                              border: 0,
                              width: '100%',
                              height: '180px'
                            }}
                            allowFullScreen
                            loading='lazy'
                          />
                        </div>

                        <div className='mt-auto d-flex justify-content-end'>
                          <button
                            className='btn btn-sm btn-outline-secondary me-2'
                            title='تعديل بيانات الموقع'
                            data-bs-toggle='modal'
                            data-bs-target='#modalEditLocation'
                            onClick={() => setId(item.id)}
                          >
                            <i className='fas fa-edit'></i>
                          </button>
                        </div>
                      </div>
                    </Card>
                  </div>
                ))}
              </div>

              {filteredSearch?.length > 0 && (
                <div className='mt-4'>
                  <Pagination
                    filteredData={filteredSearch}
                    dataPerPage={dataPerPage}
                    handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </div>
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddLocation')} id='modalAddLocation'>
        {Show && <AddLocations />}
      </ModalComponent>
      <ModalComponent title={t('EditLocation')} id='modalEditLocation'>
        {Id && <UppdateLocations Id={Id} />}
      </ModalComponent>
    </div>
  );
};

export default Index;

//  {/* <div className='mb-5'>
//             <div className='row'>
//               {currentData?.map((item: any) => (
//                 <div className='col-xl-4' key={item.id}>
//                   <Card className='m-2'>
//                     <div className='m-1 bg-white bg-opacity-15'>
//                       <iframe
//                         title='Youtube'
//                         src={`http://www.google.com/maps/embed/v1/place?q=${item.latitude},${item.longitude}&key=AIzaSyCG3Kt_jO8o7x67EsdV9RuTJP5IxSEwmeo`}
//                         style={{
//                           border: 0,
//                           width: '100%',
//                           height: '10rem'
//                         }}
//                         allowFullScreen
//                       ></iframe>
//                       <div className='list-group list-group-flush'>
//                         <div className='list-group-item d-flex'>
//                           <div className='w-30px h-40px d-flex align-items-center justify-content-center'>
//                             <i className='fas fa-lg fa-fw me-2 fa-location-arrow'></i>
//                           </div>
//                           <div className='flex-fill px-3'>
//                             <div className='fw-bold'>{i18n.language === 'ar' ? item.name2 : item.name}</div>
//                           </div>
//                           <button
//                             hidden={!HasPermission('FleetEditLocation')}
//                             type='button'
//                             className='btn btn-sm btn-outline-theme  '
//                             data-toggle='tooltip'
//                             title='تعديل بيانات الموقع'
//                             onClick={() => Navigate(`${item.id}/Edit`)}
//                           >
//                             <i className='fas fa-edit  '></i>
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </Card>
//                 </div>
//               ))}
//             </div>
//           </div> */}
